<script>
    import { onDestroy, createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';
    import { portal } from 'svelte-portal';
    import { API_CONFIG } from '../../config/api';

    export let figure;
    export let referenceRect;

    let tooltip;
    let isVisible = true;
    const dispatch = createEventDispatcher();

    function handleMouseMove(e) {
        if (!tooltip) return;

        const isInTooltip = e.clientX >= tooltip.offsetLeft && 
                           e.clientX <= tooltip.offsetLeft + tooltip.offsetWidth &&
                           e.clientY >= tooltip.offsetTop && 
                           e.clientY <= tooltip.offsetTop + tooltip.offsetHeight;
        
        const isInReference = e.clientX >= referenceRect.left && 
                            e.clientX <= referenceRect.right &&
                            e.clientY >= referenceRect.top && 
                            e.clientY <= referenceRect.bottom;
        
        if (!isInTooltip && !isInReference) {
            isVisible = false;
            dispatch('close');
        }
    }

    onDestroy(() => {
        document.removeEventListener('mousemove', handleMouseMove);
    });
</script>

<svelte:window on:mousemove={handleMouseMove} />

{#if isVisible}
    <div 
        class="figure-reference-tooltip fixed z-tooltip"
        bind:this={tooltip}
        style=" top: {referenceRect.bottom + 5}px;left: {referenceRect.left}px"
        transition:fade|local={{ duration: 100 }}
        use:portal={'body'}
    >
        {#if figure.imageData || figure.previewUrl}
            <img 
                src={figure.imageData || `${API_CONFIG.PATDRAW_API_URL}${figure.previewUrl}`} 
                alt={figure.name || 'Figure preview'} 
            />
        {/if}
    </div>
{/if}

<style>
    .figure-reference-tooltip {
        overflow: hidden;
        background: var(--color-spec-figure-bg);
        border-radius: var(--border-radius-lg);
        box-shadow: var(--shadow-lg);
    }

    img {
        display: block;
        max-width: 220px;  /* Adjusted to match backend preview width */
        max-height: 284px; /* Maintains 8.5:11 US Letter ratio */
        padding: var(--spacing-2);
        padding-right: calc(var(--spacing-2) + var(--spacing-2)); /* Extra side padding for symmetry */
        padding-bottom: calc(var(--spacing-2) + var(--spacing-2)); /* Extra bottom padding for visual balance */
        padding-left: calc(var(--spacing-2) + var(--spacing-2)); /* Extra side padding for symmetry */
        object-fit: contain;
    }
</style>
